import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplySubCategoryQuery = gql`query get_supply_sub_category{
  supply_sub_categories(where: {status: {_eq: "ACTIVE"}}, order_by: {name: asc}){
    id
    name
    supply_category_id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplySubCategoryService {

  constructor(private apollo: Apollo) { }

  getSupplySubCategory(){
    return this.apollo.use('external').query({
      query: getSupplySubCategoryQuery
    }).pipe(pluck('data', 'supply_sub_categories'));
  }
}
